import { Link, useSearchParams } from "react-router-dom";
import { BondRequestsPanel } from "@/components/BondRequestsPanel";

// The brokerage's own bond orders (BRK-S088) — the Surety platform's counterpart
// to SubmissionsPage, and the thing that makes a bond draft findable again.
//
// The pointer row exists from DRAFT START, so a half-filled order is listed with
// its SB number just like a filed one; the number links into the flow, which
// resumes it from the server (`/surety/submissions/:id`). Own-scoped server-side:
// PMS forces the brokerage from the session, so nothing is sent.
//
// ── THE LIST ITSELF MOVED OUT (BRK-S174) ─────────────────────────────────────
//
// This page owned the fetch, the states and the table until the Construction
// Bonds landing became the SECOND surface showing the same list. They are now
// one `BondRequestsPanel` and this page is its FULL-PAGE route: the heading, the
// New-submission button and the one-insured notice. A copy on the landing would
// have been a copy of the fetch, the filters, the empty state and the error
// state — four places to fix the next defect.
//
// TWO FILTERS ARRIVE IN THE URL, and one of them still has no control.
// `?status=` and `?decision=` are the panel's own (PMS-S461), applied
// server-side. `?accountId=` stays a LINK rather than a control (BRK-S140): the
// account profile's Submissions tab links here with it, so "this insured's bond
// orders" is a shareable, reloadable page. It is additive to the own-scoping —
// PMS still forces the brokerage from the session — which is what makes it safe
// to read an id straight out of the query string.
//
// Still no pager: the seam supports paging, but wiring the control is its own
// change, and scaffolding that does not page would misrepresent the list.

export function BondSubmissionsPage() {
  const [params] = useSearchParams();
  const accountId = params.get("accountId") ?? undefined;

  return (
    <section className="flex w-full flex-col gap-6 py-8">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold tracking-tight">
            Bond submissions
          </h1>
          <p className="text-brk-dim">
            {accountId
              ? "Bond orders for one insured — drafts included."
              : "Your brokerage’s surety bond orders — drafts included."}
          </p>
        </div>
        <Link
          to="/surety/submissions/new"
          className="inline-flex items-center gap-2 rounded-md bg-brk-accent px-4 py-2 font-medium text-white transition-colors hover:bg-brk-accent-strong"
        >
          <span aria-hidden="true" className="text-base leading-none">
            +
          </span>
          New bond submission
        </Link>
      </div>

      {/* Says the list is NARROWED, and offers the way out. A filtered list that
          looks like the whole list is how a broker concludes they have three
          bond orders in total. */}
      {accountId && (
        <p className="text-sm text-brk-dim">
          Showing one insured&apos;s orders.{" "}
          <Link
            to="/surety/submissions"
            className="text-brk-accent hover:underline"
          >
            Show all bond submissions
          </Link>
        </p>
      )}

      <BondRequestsPanel accountId={accountId} />
    </section>
  );
}
